export default __webpack_public_path__ + "3657a93a3db60b12358328875a0a59c4.png";